const Component = () => import('./FirstDelivery');

export { Component };
